import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ShellDomainProvider, UtilityService } from '@ecap3/core';
import { Observable } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';
import { OrganizationDocuments } from '../../app-organizational-documents/interface/organization-documents.interface';
import { IDeltaApiCommonResponseV2 } from '../../../shared/interfaces/business-service.interface';

@Injectable()
export class DocumentService { 
    private readonly header: any = new HttpHeaders({
        'Content-Type': 'application/json'
    });

    private readonly commonOptions: any = {
        headers: this.header,
        withCredentials: true,
        observe: 'body'
    };

    constructor(
        private readonly http: HttpClient,
        private readonly utilityService: UtilityService
    ) {}

    getOrganizationalDocuments({
        IsPublished,
        IsArchived = false,
        DocumentId = '',
        ParentId = '',
        SearchKey = '',
        SearchAllSubFolders = false
    }: {
        IsPublished?: boolean;
        IsArchived?: boolean;
        DocumentId: string;
        ParentId: string;
        SearchKey: string;
        SearchAllSubFolders: boolean;
    }): Observable<OrganizationDocuments[]> {
        let url =
            ShellDomainProvider['api'].BusinessService +
            `DeltaService/OrganizationalDocument/Search?PageNumber=0&PageSize=999&DocumentId=${DocumentId}&ParentId=${ParentId}&IsArchived=${IsArchived}&SearchKey=${SearchKey}&SearchAllSubFolders=${SearchAllSubFolders}`;
        if (IsPublished !== undefined) {
            url += `&IsPublished=${IsPublished}`;
        }
        return this.http.get(url, this.commonOptions).pipe(
            take(1),
            tap((res: unknown) => {
            }),
            map((res: IDeltaApiCommonResponseV2<OrganizationDocuments[]>) => {
                if (res.IsSuccess) {
                    return res.Data;
                }
                throw new Error(
                    res.Errors.map((err) => err.ErrorMessage).join(', ')
                );
            })
        );
    }
    createFileOrFolder(
        payload: Pick<
            OrganizationDocuments,
            | 'Name'
            | 'Description'
            | 'FileId'
            | 'Type'
            | 'ParentId'
            | 'Extension'
        >
    ): Observable<any> {
        const ItemId = this.utilityService.getNewGuid();
        const modifiedPayload = {
            ...payload,
            ItemId,
            ParentId: payload.ParentId || ''
        };
        return this.http
            .post(
                ShellDomainProvider['api'].BusinessService +
                    `DeltaService/OrganizationalDocument/CreateDocument`,
                modifiedPayload,
                this.commonOptions
            )
            .pipe(
                take(1),
                tap((res: unknown) => {
                }),
                map(
                    (
                        res: IDeltaApiCommonResponseV2<OrganizationDocuments[]>
                    ) => {
                        if (res.IsSuccess) {
                            return res.Data;
                        }
                        throw new Error(
                            res.Errors.map((err) => err.ErrorMessage).join(', ')
                        );
                    }
                )
            );
    }
}
